import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'

// Apollo client
import { withApollo } from '@apollo/client/react/hoc'
import { getLastAppointmentsLimit } from '../../graphql/appointment'

// Design imports
import { Button, Divider, List, ListItem, Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import CheckIcon from '@material-ui/icons/Check'
import moment from 'moment/moment'
import compose from '../../utils/functions'

class AppointmentList extends React.Component {
    // TODO Add limit to appointment list query

    state = {
        appointments: [],
    }

    componentDidMount() {
        this.props.client.query(getLastAppointmentsLimit(0, 20)).then((result) => {
            this.setState({ appointments: result.data.allAppointments.appointments })
        })
    }

    goToPatient = (id) => {
        this.props.history.push('/patient/' + id)
    }

    goToNotificationsList = () => {
        this.props.history.push('/appointments')
    }

    handleRowClick = (id, type) => {
        this.props.history.push('/appointment/' + id)
    }

    renderListItem = (item, index) => {
        const { classes } = this.props

        var actions = null
        actions = (
            <Button
                variant="outlined"
                color="primary"
                size="small"
                className={classes.actionButton}
                onClick={() => this.handleRowClick(item.id, item.type)}>
                Veure més
            </Button>
        )
        if (item.confirmed) {
            actions = (
                <div>
                    <CheckIcon className={classes.actionConfirmedIcon} />
                    <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        className={classes.actionButton}
                        onClick={() => this.handleRowClick(item.id, item.type)}>
                        Veure més
                    </Button>
                </div>
            )
        }

        var warningEdge = null
        if (item.type === 'warning') {
            warningEdge = <div className={classes.warningEdge} />
        }

        return (
            <ListItem divider={index < 4} className={classes.listItem}>
                {warningEdge}
                <div className={classes.listItemContainer}>
                    <Typography variant="subtitle1" color="textPrimary">
                        {item.proposedDate !== null
                            ? 'Visita proposada: ' +
                              item.proposedHour +
                              ' - ' +
                              moment(parseInt(item.proposedDate)).format('DD/MM/YYYY')
                            : "Petició d'hora efectuada"}
                    </Typography>
                    <div className={classes.listItemFooter}>
                        <a
                            className={classes.link}
                            onClick={(event) => {
                                event.stopPropagation()
                                this.goToPatient(item.patient.id)
                            }}>
                            <Typography className={classes.listItemDate} variant="subtitle2" color="textSecondary">
                                {moment(parseInt(item.createdAt)).format('DD/MM/YYYY - HH:mm')} -{' '}
                                {item.patient?.name?.toUpperCase() + ' ' + item.patient?.lastName?.toUpperCase()}
                            </Typography>
                        </a>
                        {actions}
                    </div>
                </div>
            </ListItem>
        )
    }

    render() {
        const { classes } = this.props
        const { appointments } = this.state

        return (
            <List className={classes.list}>
                <div className={classes.listContent}>
                    {appointments.slice(0, 5).map((item, index) => this.renderListItem(item, index))}
                </div>
                <Divider />
                <ListItem>
                    <Button fullWidth color="primary" onClick={() => this.goToNotificationsList()}>
                        Veure totes
                    </Button>
                </ListItem>
            </List>
        )
    }
}

const styles = (theme) => ({
    list: {
        paddingTop: 0,
        paddingBottom: 0,
    },
    listItem: {
        paddingRight: '16px',
        paddingLeft: '24px',
    },
    listItemContainer: {
        flex: 1,
    },
    listItemDate: {
        paddingTop: '8px',
        color: theme.palette.primary.light,
    },
    link: {
        textDecoration: 'none',
        cursor: 'pointer',
    },
    listItemFooter: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        // paddingTop: '8px'
    },
    actionButton: {
        width: '100px',
        marginLeft: '8px',
    },
    actionConfirmedIcon: {
        color: theme.palette.primary.light,
    },
    warningEdge: {
        position: 'absolute',
        width: '4px',
        height: '100%',
        marginLeft: '-24px',
        marginRight: '20px',
        backgroundColor: theme.palette.secondary.main,
    },
    listContent: {
        maxHeight: '200px',
        overflow: 'hidden',
        overflowY: 'scroll',
    },
})

AppointmentList.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default compose(withRouter, withApollo, withStyles(styles))(AppointmentList)
